"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInfoApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var AddressInfoApi = /** @class */ (function () {
    function AddressInfoApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 添加地址,查询地址列表
     * @method POST 添加地址
     * @method GET 查询地址列表
     *
     */
    AddressInfoApi.prototype.AddressInfo = function () {
        return this.http
            .url("/api/AddressInfo")
            .addSecurityHeaders()
            .support('POST', 'GET');
    };
    /**
     * 删除地址,更新更新,获取指定Id地址信息
     * @method DELETE 删除地址
     * @method PUT 更新更新
     * @method GET 获取指定Id地址信息
     *
     * @params id 无说明
     */
    AddressInfoApi.prototype.AddressInfoById = function (id) {
        return this.http
            .url("/api/AddressInfo/" + id)
            .addSecurityHeaders()
            .support('DELETE', 'PUT', 'GET');
    };
    /**
     * 设置默认收货地址
     * @method PUT 设置默认收货地址
     *
     * @params id 无说明
     */
    AddressInfoApi.prototype.default = function (id) {
        return this.http
            .url("/api/AddressInfo/" + id + "/default")
            .addSecurityHeaders()
            .support('PUT');
    };
    AddressInfoApi.diOptions = di_1.default.options({
        name: "AddressInfoApi",
        scope: "Singleton"
    });
    return AddressInfoApi;
}());
exports.AddressInfoApi = AddressInfoApi;
exports.default = AddressInfoApi;
